import { Button } from '@heroui/react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@stores/authStore';
import { PaymentStatus } from '../../types/auth';

// Fully-paid tiers — the upgrade CTA is hidden for these.
const PAID_STATUSES: string[] = [
  PaymentStatus.STARTER,
  PaymentStatus.STARTUP,
  PaymentStatus.PRO,
];

function CrownIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M3 7l4 4 5-6 5 6 4-4-1.5 11h-15L3 7zm2.2 13h13.6a1 1 0 010 2H5.2a1 1 0 010-2z" />
    </svg>
  );
}

/**
 * Sidebar "Upgrade Plan" CTA card (Figma image 1, bottom-left).
 * Net-new UI. Visibility is driven by real plan data: shown unless the user is
 * on a fully-paid tier (`PaymentInfo.paymentStatus` is typed as `string`, so we
 * compare against the `PaymentStatus` constants rather than narrowing).
 */
export function UpgradePlanCard() {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const status = user?.payment?.paymentStatus;

  if (status && PAID_STATUSES.includes(status)) {
    return null;
  }

  return (
    <div className="px-3 py-2">
      <div className="rounded-2xl border border-white/15 bg-gradient-to-br from-[#3e1dd7]/50 to-purple-600/30 p-4 text-white">
        <div className="mb-1 flex items-center gap-2">
          <CrownIcon className="h-5 w-5 text-amber-300" />
          <span className="font-semibold">Upgrade Plan</span>
        </div>
        <p className="mb-3 text-xs text-white/70">
          Unlock more AI Staff and advanced features.
        </p>
        <Button
          onPress={() => navigate('/settings?tab=billing')}
          size="sm"
          className="w-full bg-white/95 font-semibold text-purple-700"
        >
          Upgrade Now
        </Button>
      </div>
    </div>
  );
}
